import React from "react"

const CheckboxOrRadioGroup = (props) => (  
  <div className="form-row form-row-checkradio" title={props.title}>
    {props.options.map(opt => {
      return (
        <label key={opt.value} className="form-checkradio-label">
          <input
            className="form-checkradio-input"
            name={props.setName}
            onChange={props.controlFunc}
            value={opt.value}
            checked={ props.selectedOptions.indexOf(opt.value) > -1 }
            type={props.type} /><span className="form-checkradio-input-checked"></span>{opt.label}</label>
      );
    })}
  </div>
);

export default CheckboxOrRadioGroup;


// WEBPACK FOOTER //
// ./src/components/CheckRadio.js